<template>
  <v-dialog v-model="show" max-width="630">
    <template #activator="{ on, attrs }">
      <slot :on="on" :attrs="attrs"></slot>
    </template>
    <v-card>
      <v-card-title>
        Přidat partnera
      </v-card-title>
      <v-form @submit.prevent="addPartner()" class="">
        <v-col>
          <v-text-field hide-details="auto" v-model="data.name" label="Jméno partnera" outlined filled dense />
        </v-col>
        <v-col>
          <v-text-field hide-details="auto" v-model="data.address" label="Adresa" outlined filled dense />
        </v-col>
        <v-col>
          <v-text-field hide-details="auto" v-model="data.ico" label="IČO" outlined filled dense />
        </v-col>
        <v-col>
          <v-text-field hide-details="auto" v-model="data.phoneNumber" label="Telefonní číslo" outlined filled dense />
        </v-col>
        <v-col>
          <v-text-field hide-details="auto" v-model="data.email" label="Email" outlined filled dense />
        </v-col>
        <v-card-actions>
          <v-btn outlined color="primary" @click="close()">Zrušit</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit">PŘIDAT</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AddPartnerDialog",
  props: {

  },
  data() {
    return {
      data: {},
      show: false,
    }
  },
  mounted() {
    this.syncData()
  },
  methods: {
    addPartner() {
      this.axios.post('/v1/partners',this.data).then((data)=>{
        this.$emit('update',data.data)
        this.close()
      })
          .catch((el) => {
            if (el.response && el.response.data && el.response.data.errors) {
              el.response.data.errors.forEach((error) => {
                this.$store.commit('addAlert', {
                  type: 'error',
                  message: error.message
                })
              })
            } else {
              this.$store.commit('addAlert', {
                type: 'error',
                message: "Chyba"
              })
            }
          })
    },
    close() {
      this.show = false
    }
  },
  computed: {

  },
  watch: {
  }
}
</script>

<style scoped>

</style>